"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-fdm-fused-deposition-modeling";

export default function FdmDesignGuidelines() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
					{t("fdmDesignGuidelinesTitle")}
				</h2>
				<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base lg:mb-12">
					{t("fdmDesignGuidelinesDesc")}
				</p>

				<div className="overflow-x-auto bg-[#f6ffde]">
					<table
						className="w-full min-w-[760px] border-collapse text-left"
						style={{ border: "1px solid #cdcfc7" }}
					>
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="border border-[#cdcfc7] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesColParameter")}
								</th>
								<th className="border border-[#cdcfc7] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesColCategory")}
								</th>
								<th className="border border-[#cdcfc7] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesColUS")}
								</th>
								<th className="border border-[#cdcfc7] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesColMetric")}
								</th>
							</tr>
						</thead>
						<tbody>
							{/* Max Part Size - Prototyping */}
							<tr>
								<th
									scope="row"
									rowSpan={2}
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowMaxPartSize")}
								</th>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeCat1")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeUS1")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeMetric1")}
								</td>
							</tr>
							{/* Max Part Size - Industrial */}
							<tr>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeCat2")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeUS2")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMaxPartSizeMetric2")}
								</td>
							</tr>
							{/* Dimensional Accuracy - Prototyping */}
							<tr>
								<th
									scope="row"
									rowSpan={2}
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowDimAccuracy")}
								</th>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyCat1")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyUS1")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyMetric1")}
								</td>
							</tr>
							{/* Dimensional Accuracy - Industrial */}
							<tr>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyCat2")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyUS2")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowDimAccuracyMetric2")}
								</td>
							</tr>
							{/* Unsupported/Supported Walls */}
							<tr>
								<th
									scope="row"
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowWalls")}
								</th>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base" />
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowWallsUS")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowWallsMetric")}
								</td>
							</tr>
							{/* Minimum Feature Size */}
							<tr>
								<th
									scope="row"
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowMinFeature")}
								</th>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base" />
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMinFeatureUS")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMinFeatureMetric")}
								</td>
							</tr>
							{/* Minimum Hole Diameter */}
							<tr>
								<th
									scope="row"
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowMinHole")}
								</th>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base" />
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMinHoleUS")}
								</td>
								<td className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base">
									{t("fdmDesignGuidelinesRowMinHoleMetric")}
								</td>
							</tr>
							{/* Layer Height Options */}
							<tr>
								<th
									scope="row"
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowLayerHeight")}
								</th>
								<td
									colSpan={3}
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowLayerHeightValue")}
								</td>
							</tr>
							{/* Infill Options */}
							<tr>
								<th
									scope="row"
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowInfill")}
								</th>
								<td
									colSpan={3}
									className="border border-[#cdcfc7] px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base"
								>
									{t("fdmDesignGuidelinesRowInfillValue")}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
